import { Component, Input, OnInit } from '@angular/core';
import { TicketResponse } from 'src/app/flight/models/Ticket';
import { StatusTicketCard } from 'src/app/flight/models/StatusTicketCard';
import { DialogConfirmComponent } from 'src/app/shared/components/dialog-confirm/dialog-confirm.component';
import { MatDialog } from '@angular/material/dialog';
import { PasseLivreService } from 'src/app/core/services/passe-livre/passe-livre.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { DialogInfoComponent } from 'src/app/shared/components/dialog-info/dialog-info.component';
import { MyFlightsComponent } from '../my-flights/my-flights.component';
import { CREW_INFO, getItemFromSessionStorage } from 'src/app/utils/SessionStorageUtil';
import { CrewInfo } from 'src/app/models/CrewInfo';
import { CancelTicketRequest } from '../models/CancelTicketRequest';
import { DefaultResponse } from 'src/app/models/DefaultResponse';

@Component({
    selector: 'app-card-ticket-multi',
    templateUrl: './card-ticket-multi.component.html',
    styleUrls: ['./card-ticket-multi.component.scss'],
    standalone: false
})
export class CardTicketMultiComponent implements OnInit {

  public StatusTicketCard = StatusTicketCard;

  @Input() ticket1?: TicketResponse;
  @Input() ticket2?: TicketResponse;
  @Input() status: StatusTicketCard;
  @Input() ActiveTicketList: TicketResponse;

  public isActive: boolean;

  constructor(
    private dialog: MatDialog, 
    private passeLivreService: PasseLivreService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.isActive = this.status === StatusTicketCard.ACTIVE;
  }

  cancelTicket(): void {
    const html = 'Para confirmar seu cancelamento, clique em "Confirmar".<br>ATENÇÃO: Ao cancelar uma reserva, todos os voos associados à mesma serão cancelados.';
    const dialogConfirmRef = this.dialog.open(DialogConfirmComponent, {
      data: { title: 'Cancelar Voo', html }
    });

    dialogConfirmRef.afterClosed().subscribe((confirm: boolean) => {
      if (confirm && this.ticket1 && this.ticket2) {
        this.cancelTicketProcess(this.ticket1);
        this.cancelTicketProcess(this.ticket2);
      }
    });
  }

  private cancelTicketProcess(ticket: TicketResponse): void {
    const crewInfo = getItemFromSessionStorage<CrewInfo>(CREW_INFO);

    if (crewInfo) {
      const cancelTicketRequest = this.createCancelTicketRequest(ticket, crewInfo);

      this.passeLivreService.cancelTicket(cancelTicketRequest).subscribe({
        next: (response: DefaultResponse) => {
          if (response.status === 0) {
            this.notificationService.success(`Ticket ${ticket.flightNumber} cancelado com sucesso!`);
            MyFlightsComponent.instance.refreshTickets();
          } else {
            this.showErrorDialog(response.message);
          }
        },
        error: () => {
          this.notificationService.error('Houve um erro ao cancelar o ticket!');
        }
      });
    } else {
      this.notificationService.error('Não foi possível cancelar o ticket, o sistema não conseguiu recuperar o nome do tripulante.');
    }
  }

  private createCancelTicketRequest(ticket: TicketResponse, crewInfo: CrewInfo): CancelTicketRequest {
    return {
      pnrCode: ticket.pnrCode,
      givenName: crewInfo.fullName,
      flightDate: ticket.departureDateLt
    };
  }

  private showErrorDialog(error: string): void {
    const html = `<span class="error-message">${error}</span>`;
    this.dialog.open(DialogInfoComponent, {
      width: '600px',
      data: { title: 'Ocorreu um erro!', html }
    });
  }

  copyText(text: string): void {
    if (!text) return;
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = text;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }
}
